<script setup lang="ts">
    import { Voucher } from '@/types';
    import { computed } from 'vue';
    import HoverInfo from '@/components/HoverInfo.vue';
    import { useI18n } from 'vue-i18n';
    import { BrainCircuit, CreditCard, Undo, Waypoints } from 'lucide-vue-next';

    interface Props {
        voucher: Voucher;
    }
    const props = defineProps<Props>();

    const { t } = useI18n();

    const assigneeNames = computed(() => {
        const employeeNames = (props.voucher.assigned ?? []).map((assigned) => assigned.full_name);
        const userNames = (props.voucher.assigned_users ?? []).map((assignedUser) => assignedUser.name);

        return [...employeeNames, ...userNames].filter(Boolean).join(', ');
    });

    const icon = computed(() => {
        if (props.voucher.assigned_by === 'credit_card') {
            return CreditCard;
        }
        if (props.voucher.assigned_by === 'transaction') {
            return Waypoints;
        }
        if (props.voucher.assigned_by === 'api') {
            return BrainCircuit;
        }
        if (props.voucher.assigned_by === 'fallback') {
            return Undo;
        }
    });
</script>

<template>
    <span class="flex items-center gap-2">
        {{ assigneeNames }}
        <HoverInfo
            v-if="voucher.assigned_by"
            :content="t('vouchers.assigned_by.' + voucher.assigned_by)"
        >
            <template #icon>
                <component
                    :is="icon"
                    class="text-secondary size-5 shrink-0"
                />
            </template>
        </HoverInfo>
    </span>
</template>
